var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-info" },
    [
      _c(
        "el-form",
        _vm._b(
          {
            ref: "formRef",
            staticClass: "form",
            attrs: { model: _vm.form, rules: _vm.rules },
          },
          "el-form",
          _vm.formConfig,
          false
        ),
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品类型：", prop: "storeName" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.productType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "productType", $$v)
                    },
                    expression: "form.productType",
                  },
                },
                _vm._l(_vm.goodsTypeEnum, function (rad) {
                  return _c(
                    "el-radio",
                    { key: rad.value, attrs: { label: rad.value } },
                    [_vm._v(_vm._s(rad.label))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "商品分类：", prop: "cateIds" } },
            [
              _c("el-cascader", {
                ref: "cateIdsRef",
                attrs: {
                  options: _vm.comData.cateIdsOption,
                  props: _vm.props,
                  clearable: "",
                },
                on: { change: _vm.getSpuCode },
                model: {
                  value: _vm.form.cateIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "cateIds", $$v)
                  },
                  expression: "form.cateIds",
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addCate } },
                [_vm._v("新增分类")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "展示分类：", prop: "showCateId" } },
            [
              _c("el-cascader", {
                attrs: {
                  options: _vm.comData.showCateIdOption,
                  props: Object.assign({}, _vm.props, { multiple: true }),
                  clearable: "",
                },
                model: {
                  value: _vm.form.showCateId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "showCateId", $$v)
                  },
                  expression: "form.showCateId",
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addShowCate } },
                [_vm._v("新增分类")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "SPU名称：", prop: "storeName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入商品名称" },
                on: { change: _vm.getSpuCode },
                model: {
                  value: _vm.form.storeName,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "storeName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.storeName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "商品轮播图：", prop: "sliderImages" } },
            [
              _c(
                "div",
                { staticClass: "slider-images" },
                [
                  _vm.form.sliderImages
                    ? _c(
                        "SortImgVue",
                        {
                          attrs: {
                            imgUrlList: _vm.form.sliderImages,
                            changeList: _vm.changeSliderImages,
                          },
                        },
                        [
                          _vm.userType === 1 &&
                          _vm.form.sliderImages &&
                          _vm.form.sliderImages.length < 10
                            ? _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                                on: { click: _vm.upLoadSliderImages },
                              })
                            : _vm.userType !== 1 &&
                              _vm.form.sliderImages &&
                              _vm.form.sliderImages.length < 10
                            ? _c(
                                "el-upload",
                                {
                                  staticClass: "slider-uploader",
                                  attrs: {
                                    action: "",
                                    "show-file-list": false,
                                    "http-request": _vm.handleSliderUpload,
                                    "before-upload": _vm.beforeSliderUpload,
                                    accept: "image/*",
                                    multiple: "",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-plus slider-uploader-icon",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-alert", {
                    staticClass: "image-upload-tip",
                    attrs: {
                      closable: false,
                      title: "建议上传分辨率为800×800px的图片，大小≤1000KB",
                      type: "warning",
                      "show-icon": "",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          Number(_vm.form.productType) === 18
            ? _c(
                "el-form-item",
                { attrs: { label: "卡片样式：", prop: "cardImage" } },
                [
                  _c(
                    "div",
                    { staticClass: "card-upload" },
                    [
                      _vm.form.cardImage
                        ? _c("div", { staticClass: "card-preview" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.form.cardImage,
                                alt: "卡片样式",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "card-overlay" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: { click: _vm.handleCardImageUpload },
                                  },
                                  [_vm._v("更换图片")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "danger" },
                                    on: { click: _vm.removeCardImage },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _c(
                            "div",
                            {
                              staticClass: "card-placeholder",
                              on: { click: _vm.handleCardImageUpload },
                            },
                            [
                              _c("i", { staticClass: "el-icon-plus" }),
                              _vm._v(" "),
                              _c("p", [_vm._v("上传卡片样式")]),
                            ]
                          ),
                      _vm._v(" "),
                      _c("el-alert", {
                        staticClass: "image-upload-tip",
                        attrs: {
                          closable: false,
                          title: "建议上传分辨率为880×400px的图片，大小≤500KB",
                          type: "warning",
                          "show-icon": "",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "商品状态：", prop: "isShow" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.isShow,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "isShow", $$v)
                    },
                    expression: "form.isShow",
                  },
                },
                _vm._l(_vm.goodsStatusEnum, function (rad) {
                  return _c(
                    "el-radio",
                    { key: rad.value, attrs: { label: rad.value } },
                    [_vm._v(_vm._s(rad.label))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.productType === 2
            ? _c(
                "el-form-item",
                { attrs: { label: "授权接收卡密：", prop: "authMsg" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.authMsg,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "authMsg", $$v)
                        },
                        expression: "form.authMsg",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { color: "#999" } }, [
                    _vm._v("如选择是，在商品下单后将弹出接收卡密信息的通知"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "供应商：", prop: "supplierId" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    placeholder: "请选择",
                    "remote-method": _vm.remoteMethod,
                    filterable: "",
                    "filter-method": _vm.handleSupplierSearch,
                  },
                  model: {
                    value: _vm.form.supplierId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "supplierId", $$v)
                    },
                    expression: "form.supplierId",
                  },
                },
                _vm._l(_vm.comData.suppliers, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.supplierName, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "品牌：", prop: "brandIdObj" } },
            [
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      placeholder: "请选择",
                      filterable: "",
                      remote: "",
                      size: "small",
                      "value-key": "brandName",
                      clearable: "",
                    },
                    on: { change: _vm.getSpuCode },
                    model: {
                      value: _vm.form.brandIdObj,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "brandIdObj", $$v)
                      },
                      expression: "form.brandIdObj",
                    },
                  },
                  _vm._l(_vm.comData.brandList, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.brandName, value: item },
                    })
                  }),
                  1
                ),
              ],
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "SPU编码：", prop: "spuCode" } },
            [
              _c("el-input", {
                attrs: { disabled: Boolean(_vm.form.id), disabled: "" },
                model: {
                  value: _vm.form.spuCode,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "spuCode",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.spuCode",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.productType == 1
            ? _c(
                "el-form-item",
                { attrs: { label: "运费模板：", prop: "tempId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.form.tempId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "tempId", $$v)
                        },
                        expression: "form.tempId",
                      },
                    },
                    _vm._l(_vm.comData.shippingList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.addTem } },
                    [_vm._v("运费模板")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "进项税率：", prop: "taxKey" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.form.taxKey,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "taxKey", $$v)
                    },
                    expression: "form.taxKey",
                  },
                },
                _vm._l(_vm.comData.taxKeyEnum, function (opt) {
                  return _c("el-option", {
                    key: opt.id,
                    attrs: { value: opt.id, label: opt.name },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.productType === 1,
                  expression: "form.productType === 1",
                },
              ],
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "产地：" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.comData.citys,
                      props: Object.assign({}, _vm.props, {
                        checkStrictly: true,
                      }),
                      clearable: "",
                      size: "small",
                    },
                    model: {
                      value: _vm.form.areaId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "areaId", $$v)
                      },
                      expression: "form.areaId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品属性：" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.productAttr,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "productAttr", $$v)
                        },
                        expression: "form.productAttr",
                      },
                    },
                    _vm._l(_vm.comData.productAttrEnum, function (rad) {
                      return _c(
                        "el-checkbox",
                        { key: rad.id, attrs: { label: rad.id } },
                        [_vm._v(_vm._s(rad.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.documentationFiles.length > 0
                ? _c("el-form-item", { attrs: { label: "资质证明：" } }, [
                    _c(
                      "div",
                      { staticClass: "documentation-list" },
                      [
                        _vm._l(_vm.documentationFiles, function (file, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "documentation-item" },
                            [
                              _c("el-tag", { attrs: { size: "medium" } }, [
                                _c("i", { class: _vm.getFileIcon(file.url) }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "file-name",
                                    on: {
                                      click: function ($event) {
                                        return _vm.previewDocument(file)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        file.name || _vm.getFileName(file.url)
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "download-button",
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.downloadDocument(file)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-download" }),
                                  _vm._v(" 下载\n              "),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _vm.documentationFiles.length === 0
                          ? _c("div", { staticClass: "no-files" }, [
                              _vm._v(
                                "\n              暂无资质证明文件\n            "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "品牌是否授权：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.isBrandAuthorize,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isBrandAuthorize", $$v)
                        },
                        expression: "form.isBrandAuthorize",
                      },
                    },
                    _vm._l(_vm.brandAuthEnum, function (rad) {
                      return _c(
                        "el-radio",
                        { key: rad.value, attrs: { label: rad.value } },
                        [_vm._v(_vm._s(rad.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "发货时间：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "delivery-time",
                      on: { change: _vm.deliveryTimeChange },
                      model: {
                        value: _vm.form.deliveryTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "deliveryTime", $$v)
                        },
                        expression: "form.deliveryTime",
                      },
                    },
                    _vm._l(_vm.deliveryTimeEnum, function (rad) {
                      return _c(
                        "el-radio",
                        { key: rad.value, attrs: { label: rad.value } },
                        [
                          rad.value === "other"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "deliveryTimeOther" } },
                                    [
                                      _c("span", [_vm._v("其他")]),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        attrs: {
                                          disabled:
                                            _vm.form.deliveryTime !== "other",
                                        },
                                        model: {
                                          value: _vm.form.deliveryTimeOther,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "deliveryTimeOther",
                                              $$v
                                            )
                                          },
                                          expression: "form.deliveryTimeOther",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("小时")]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c("span", [_vm._v(_vm._s(rad.label))]),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品限购" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "delivery-time",
                      model: {
                        value: _vm.form.isQuota,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isQuota", $$v)
                        },
                        expression: "form.isQuota",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("\n                不限购\n            "),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("\n                  限购\n            "),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.isQuota === 1
                    ? _c(
                        "div",
                        { staticStyle: { width: "60%", "margin-top": "20px" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                              },
                            },
                            [
                              _c("el-form-item", {
                                attrs: { label: "限购模式" },
                              }),
                              _vm._v(" "),
                              _c("el-form-item", {
                                attrs: { label: "限购方案" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.form.quotaList, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.type,
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between",
                                  "margin-top": "10px",
                                },
                              },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    model: {
                                      value: item.checked,
                                      callback: function ($$v) {
                                        _vm.$set(item, "checked", $$v)
                                      },
                                      expression: "item.checked",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          item.type === 1
                                            ? "订单限购"
                                            : item.type === 2
                                            ? "用户限购"
                                            : item.type === 3
                                            ? "总库存限购"
                                            : item.type === 4
                                            ? "下单冷却"
                                            : "销售时段限购"
                                        ) +
                                        "\n                     "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    item.type !== 5
                                      ? _c("el-input-number", {
                                          attrs: {
                                            disabled: !item.checked,
                                            min: 0,
                                            max: 10000,
                                            label: "描述文字",
                                          },
                                          model: {
                                            value: item.plan,
                                            callback: function ($$v) {
                                              _vm.$set(item, "plan", $$v)
                                            },
                                            expression: "item.plan",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.type === 5
                                      ? _c("el-date-picker", {
                                          attrs: {
                                            "value-format":
                                              "yyyy-MM-dd HH:mm:ss",
                                            type: "datetimerange",
                                            "range-separator": "-",
                                            "start-placeholder": "开始日期",
                                            "end-placeholder": "结束日期",
                                          },
                                          model: {
                                            value: item.time,
                                            callback: function ($$v) {
                                              _vm.$set(item, "time", $$v)
                                            },
                                            expression: "item.time",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "padding-left": "10px" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              item.type === 1
                                                ? "单笔订单最多购买N件同一商品"
                                                : item.type === 2
                                                ? "单用户最多购买N件"
                                                : item.type === 3
                                                ? "商品全渠道可售总量限制"
                                                : item.type === 4
                                                ? "小时下单成功T小时内不可再次下单"
                                                : "指定时间段内开放购买"
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.productType === 2,
                  expression: "form.productType === 2",
                },
              ],
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品属性：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.rechargeAttr,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "rechargeAttr", $$v)
                        },
                        expression: "form.rechargeAttr",
                      },
                    },
                    _vm._l(_vm.couponsGoodsAttrsEnum, function (rad) {
                      return _c(
                        "el-radio",
                        { key: rad.value, attrs: { label: rad.value } },
                        [_vm._v(_vm._s(rad.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "账号类型：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.accountType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "accountType", $$v)
                        },
                        expression: "form.accountType",
                      },
                    },
                    _vm._l(_vm.accountTypeEnum, function (rad) {
                      return _c(
                        "el-radio",
                        { key: rad.value, attrs: { label: rad.value } },
                        [_vm._v(_vm._s(rad.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "充值类型：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.rechargeType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "rechargeType", $$v)
                        },
                        expression: "form.rechargeType",
                      },
                    },
                    _vm._l(_vm.rechargeTypeEnum, function (rad) {
                      return _c(
                        "el-radio",
                        { key: rad.value, attrs: { label: rad.value } },
                        [_vm._v(_vm._s(rad.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.productType === 110
            ? _c(
                "el-form-item",
                { attrs: { label: "充值福卡：", prop: "fuCardId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择充值福卡", clearable: "" },
                      model: {
                        value: _vm.form.fuCardId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "fuCardId", $$v)
                        },
                        expression: "form.fuCardId",
                      },
                    },
                    _vm._l(_vm.comData.fuCardList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("CreatTemplatesVue", {
        ref: "creatTemplatesVueRef",
        on: { getList: _vm.getShippingList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }